import { Modal, Form, DatePicker, TimePicker, Button } from 'antd'
import moment from 'moment'
import '../../../../CreateEvent/Screens/GeneralDetails/styles/general-details.scss'

const AddSpecialScheduleModal = ({
  addSpecialScheduleModalVisible,
  setAddSpecialScheduleModalVisible,
  selectedDates,
  setSpecialScheduleData,
  specialScheduleData,
}: any) => {
  const [form] = Form.useForm()

  const handleCancel = () => {
    setAddSpecialScheduleModalVisible(false)
  }

  const onFinish = (values: any) => {
    const newSpecialSchedule = {
      day: moment(values.date).format('YYYY-MM-DD'),
      startTime: moment(values.startTime, 'HH:mm').hour() * 60 + moment(values.startTime, 'HH:mm').minute(),
      endTime: moment(values.endTime, 'HH:mm').hour() * 60 + moment(values.endTime, 'HH:mm').minute(),
    }

    setSpecialScheduleData([...specialScheduleData, newSpecialSchedule])
    setAddSpecialScheduleModalVisible(false)
    form.resetFields()
  }

  return (
    <Modal
      open={addSpecialScheduleModalVisible}
      onCancel={handleCancel}
      className="add-special-schedule-modal"
      footer={null}
      centered
      width={400}
    >
      <h2 className="text-center text-18px w1 mb-20px">Add Special Schedule</h2>
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item
          name="date"
          label="Date"
          rules={[{ required: true, message: 'Please select date' }]}
        >
          <DatePicker
            className="w-100 form-control-field"
            placeholder="Select date"
            format="YYYY-MM-DD"
          />
        </Form.Item>

        <Form.Item
          name="startTime"
          label="Start Time"
          rules={[{ required: true, message: 'Please select start time' }]}
        >
          <TimePicker
            className="w-100 form-control-field"
            placeholder="Start time"
            format="h:mm a"
            showNow={false}
          />
        </Form.Item>

        <Form.Item
          name="endTime"
          label="End Time"
          rules={[{ required: true, message: 'Please select end time' }]}
        >
          <TimePicker
            className="w-100 form-control-field"
            placeholder="End time"
            format="h:mm a"
            showNow={false}
          />
        </Form.Item>

        <div className="flex justify-center gap-16px mt-20px">
          <Button onClick={handleCancel} className="btn-gray br-8">
            Cancel
          </Button>
          <Button type="primary" htmlType="submit" className="prim-btn cursor-pointer">
            Add
          </Button>
        </div>
      </Form>
    </Modal>
  )
}

export default AddSpecialScheduleModal
